import { useEffect } from 'react';

const canPrefetch = () => {
  const c = navigator?.connection;
  if (!c) return true;
  if (c.saveData) return false;
  const et = String(c.effectiveType || '');
  // Avoid prefetch on very slow connections.
  if (et.includes('2g')) return false;
  return true;
};

export default function RoutePrefetcher() {
  useEffect(() => {
    if (!canPrefetch()) return;

    const prefetch = () => {
      // Warm critical route chunks for faster in-app navigation.
      import('../pages/TeamPage');
      import('../pages/ContactPage');
      import('../pages/ToolkitsPage');
      import('../pages/UpdatesPage');
    };

    if ('requestIdleCallback' in window) {
      const id = requestIdleCallback(prefetch, { timeout: 2500 });
      return () => cancelIdleCallback(id);
    }
    const t = setTimeout(prefetch, 700);
    return () => clearTimeout(t);
  }, []);

  return null;
}

